import { render, staticRenderFns } from "./StampCertificado.vue?vue&type=template&id=2c328d7b&scoped=true"
import script from "./StampCertificado.vue?vue&type=script&lang=js"
export * from "./StampCertificado.vue?vue&type=script&lang=js"
import style0 from "./StampCertificado.vue?vue&type=style&index=0&id=2c328d7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c328d7b",
  null
  
)

export default component.exports